'use client';

import { c as _c } from "react/compiler-runtime";
import useEmblaCarousel from 'embla-carousel-react';
import { useTranslations } from 'next-intl';
import { type FC, useCallback, useEffect, useState } from 'react';
// import Image from 'next/image';
import { ArrowLeftOutlined, ArrowRightOutlined, Close } from '@/utils/antd-imports';
export interface AppliedFilter {
  type?: string;
  key: string;
  value: number;
  label: string;
}
interface AppliedFiltersProps {
  filters: AppliedFilter[];
  onRemove?: (filter: AppliedFilter) => void;
  className?: string;
}
export const AppliedFilters: FC<AppliedFiltersProps> = t0 => {
  const $ = _c(34);
  const {
    filters,
    onRemove,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t = useTranslations("experiences.filters");
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      align: "start",
      skipSnaps: false,
      containScroll: "trimSnaps"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t2);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  let t3;
  if ($[1] !== emblaApi) {
    t3 = () => {
      const _showLeft = emblaApi?.canScrollPrev() ?? false;
      const _showRight = emblaApi?.canScrollNext() ?? false;
      setShowLeft(_showLeft);
      setShowRight(_showRight);
    };
    $[1] = emblaApi;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleScroll = t3;
  let t4;
  let t5;
  if ($[3] !== emblaApi || $[4] !== handleScroll) {
    t4 = () => {
      handleScroll();
      emblaApi?.on("scroll", handleScroll);
    };
    t5 = [emblaApi, handleScroll];
    $[3] = emblaApi;
    $[4] = handleScroll;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== handleScroll) {
    t6 = () => {
      handleScroll();
    };
    $[7] = handleScroll;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== filters.length) {
    t7 = [filters.length];
    $[9] = filters.length;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  useEffect(t6, t7);
  const t8 = `relative flex grow shrink overflow-auto ${className}`;
  let t9;
  if ($[11] !== filters || $[12] !== onRemove || $[13] !== t) {
    let t10;
    if ($[15] !== onRemove || $[16] !== t) {
      t10 = (filter, index) => <div key={`${filter.type}-${index}`} className="flex shrink-0 h-8 items-center rounded-full border-2 border-[#8082B233] pl-3.5 pr-2 md:h-[45px] md:border-2 md:px-5 select-none max-w-full overflow-hidden whitespace-nowrap">{filter.type && <span className="whitespace-nowrap font-['Inter'] text-[12px] leading-[1.4] text-[#8082B2] md:text-[14px]">{t(filter.type as Parameters<typeof t>[0])}:</span>}<span className="whitespace-nowrap font-['Inter'] text-[12px] font-semibold leading-[1.4] text-[#8082B2] md:text-[14px] text-ellipsis overflow-hidden max-w-full">{filter.label}</span><button type="button" onClick={() => onRemove?.(filter)} className="ml-1 flex size-[25px] items-center justify-center md:ml-2.5"><Close className="text-[12px] text-[#8082B2]" /></button></div>;
      $[15] = onRemove;
      $[16] = t;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    t9 = filters.map(t10);
    $[11] = filters;
    $[12] = onRemove;
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <div className="flex flex-wrap gap-1.5 lg:flex-nowrap max-h-full scroll-hidden overflow-y-auto lg:overflow-y-visible overflow-x-visible w-full">{t9}</div>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== emblaRef || $[21] !== t10) {
    t11 = <div className="overflow-hidden max-w-full" ref={emblaRef}>{t10}</div>;
    $[20] = emblaRef;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== emblaApi || $[24] !== showLeft) {
    t12 = showLeft && <div className="flex items-center justify-start absolute left-0 top-0 size-[45px] bg-[linear-gradient(270deg,rgba(0,0,20,0)_0%,#131424_60%)]"><button className="size-5 rounded-full flex items-center justify-center" type="button" onClick={() => emblaApi?.scrollPrev()}><ArrowLeftOutlined className="text-[#A0A3E2]" /></button></div>;
    $[23] = emblaApi;
    $[24] = showLeft;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== emblaApi || $[27] !== showRight) {
    t13 = showRight && <div className="flex items-center justify-end absolute right-0 top-0 size-[45px] bg-[linear-gradient(90deg,rgba(0,0,20,0)_0%,#131424_60%)]"><button className="size-5 rounded-full flex items-center justify-center" type="button" onClick={() => emblaApi?.scrollNext()}><ArrowRightOutlined className="text-[#A0A3E2]" /></button></div>;
    $[26] = emblaApi;
    $[27] = showRight;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t11 || $[30] !== t12 || $[31] !== t13 || $[32] !== t8) {
    t14 = <div className={t8}>{t11}{t12}{t13}</div>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
    $[32] = t8;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
};